import Vue from 'vue';
import VueI18n from 'vue-i18n'
import en from './en';
import zh from './zh';
declare var require: any;
const ElementLocale = require('element-ui/lib/locale/index.js')
Vue.use(VueI18n)
const messages = {
    en,
    zh
}
const i18n = new VueI18n({
    locale: 'en',
    messages
})
ElementLocale.i18n((key: any, value: any) => i18n.t(key, value))
export const t = i18n.t
export default i18n;